<template>
  <div class="sm-report-phone">
    <div class="sm-wrap lg">
      <breadcrumbs-block :crumbs="breadcrumbs" />

      <div class="sm-report-phone__top">
        <h3>
          Phone usage charges details
          <template v-if="period"> ({{period}})</template>
        </h3>
      </div>
      <div
        v-if="phoneRevenue.length" 
        class="sm-report-phone__table"
      >
        <table
          v-if="viewPort != 'small'"
          class="sm-table"
        >
          <thead class="sm-table__head">
            <tr class="sm-txt-upper">
              <th class="sm-table__head-item sm-txt-center">Mailbox#</th>
              <th class="sm-table__head-item">Username</th>
              <th class="sm-table__head-item">Name</th>
              <th class="sm-table__head-item sm-txt-center">Minutes</th>
              <th class="sm-table__head-item sm-txt-center">Phone</th>
              <th class="sm-table__head-item sm-txt-center">Gross revenue</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in phoneRevenue"
              :key="item.account_id"
            >
              <td class="sm-txt-center">
                {{item.pmb}}
                <!-- <a
                  href="#"
                  class="sm-link"  
                  @click.prevent="$router.push(`customer/${item.account_id}`)"
                >{{item.pmb}}</a> -->
              </td>
              <td>
                <text-truncate :text="item.user_name" />
              </td>
              <td>
                <text-truncate :text="item.name" />
              </td>
              <td class="sm-txt-center">{{item.minutes}}</td>
              <td class="sm-txt-center">{{item.phone}}</td>
              <td class="sm-txt-center">{{formatPrice(item.gross_revenue)}}</td>
            </tr>
          </tbody>
        </table>

        <div 
          v-else
          class="sm-mobile-table"
        >
          <div class="sm-mobile-table-item header">
            <div class="sm-mobile-table-item-row">
              <div class="sm-mobile-table-item-row-th sm-txt-center pmb">Mailbox#</div>
              <div class="sm-mobile-table-item-row-th name">Name</div>
              <div class="sm-mobile-table-item-row-th sm-txt-center gross-revenue">Gross revenue</div>
              <div class="sm-mobile-table-item-row-th control-arrow"></div>
            </div>
          </div>
          <div
            v-for="item in phoneRevenue"
            :key="item.account_id"
            class="sm-mobile-table-item"
            :class="{
              'open': item.isOpen
            }"
          >
            <div 
              class="sm-mobile-table-item-row"
              @click="toggleItem(item)"
            >
              <div class="sm-mobile-table-item-row-elem sm-txt-center pmb">
                {{item.pmb}}
                <!-- <a
                  href="#"
                  class="sm-link"  
                  @click.prevent="$router.push(`customer/${item.account_id}`)"
                >{{item.pmb}}</a> -->
              </div>
              <div class="sm-mobile-table-item-row-elem name">
                <text-truncate :text="item.name" />
              </div>
              <div class="sm-mobile-table-item-row-elem gross-revenue sm-txt-center">{{formatPrice(item.gross_revenue)}}</div>
              <div class="sm-mobile-table-item-row-elem control-arrow">
                <include-svg :name="'icon-arrow-b-big'" />
              </div>
            </div>
            <ul class="sm-mobile-table-item-dropdown">
              <li>
                <span class="sm-txt-capitalize">Username</span>
                <span>
                  <text-truncate :text="item.user_name" />
                </span>
              </li>
              <li>
                <span class="sm-txt-capitalize">Minutes</span>
                <span>{{item.minutes}}</span>
              </li>
              <li>
                <span class="sm-txt-capitalize">Phone</span>
                <span>{{item.phone}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p 
        v-else
        class="disabled"
      >No phone revenue</p>
    </div>

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import Spinner from '@/components/Spinner';
import ViewPort from '@/mixins/ViewPort';
import {mapActions} from 'vuex';
import {FormatPrice} from '@/utils/general-data';

export default {
  name: 'report-phone-revenue',
  components: {
    'breadcrumbs-block': Breadcrumbs,
    'sm-spinner': Spinner
  },
  data() {
    return {
      breadcrumbs: [
        {
          link: 'reports',
          name: 'admin-reports',
          text: 'Reports'
        },
        {
          link: 'report-phone-revenue',
          name: 'admin-report-phone-revenue',
          text: 'Phone usage charges details',
          current: true
        }
      ],
      month: null,
      year: null,
      phoneRevenue: [],
      allowedBreakpoints: [
        'small',
        'medium',
        'large'
      ],
      showSpinner: false,
    }
  },
  computed: {
    period() {
      if (!this.month || !this.year)
        return '';

      return this.$moment(new Date(`${this.year}-${this.month}`)).format('MMMM YYYY');
    }
  },
  created() {
    let query = this.$route.query;
    this.month = query.month;
    this.year = query.year;
  
    if (
        !this.month || 
        this.month.toLowerCase().includes('invalid') ||
        !this.year ||
        this.year.toLowerCase().includes('invalid')  
      ) {
      this.redirectToCharges();
      return;
    }

    this.getData();
  },
  mixins: [ViewPort],
  methods: {
    ...mapActions({
      getPhoneRevenue: 'reports/getPhoneRevenue'
    }),
    formatPrice: FormatPrice,
    toggleItem(item) {
      item.isOpen = !item.isOpen;
    },
    getData() {
      this.showSpinner = true;

      this.getPhoneRevenue({
        month: this.month,
        year: this.year
      })
        .then(res => {
          this.phoneRevenue = res.phone_usages.map(item => {
            return {
              ...item,
              isOpen: false
            }
          });
          this.showSpinner = false;
        })
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/general/mixins.scss';
  @import '@/assets/scss/framework/scss-variables.scss';
  @import '@/assets/scss/pages/common/reports/_report-phone.scss';
</style>